import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Hook para buscar o agregado de pets em tempo real
 * Reduz drasticamente leituras do Firebase e atualiza automaticamente
 */
export const usePetsAggregates = () => {
  const [pets, setPets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Listener em tempo real para o agregado de pets
    const petsAggregateRef = doc(db, 'agregadoPets', 'all');
    
    const unsubscribe = onSnapshot(
      petsAggregateRef,
      (snapshot) => {
        try {
          if (snapshot.exists()) {
            const data = snapshot.data();
            setPets(data.pets || []);
          } else {
            // Se o agregado não existe, retornar array vazio (não lançar erro)
            setPets([]);
          }
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      },
      (err) => {
        // Callback de erro do onSnapshot
        setError(err);
        setLoading(false);
      }
    );

    // Cleanup: remover listener quando o componente desmontar
    return () => {
      unsubscribe();
    };
  }, []);

  return { pets, loading, error };
};

